import React, { Children } from 'react';
import { LEFT, RIGHT } from '../../../constants';
export var TableRowCells = function TableRowCells(_ref) {
  var children = _ref.children,
      stickyColumns = _ref.stickyColumns,
      stickyTopVisible = _ref.stickyTopVisible,
      stickyLeftColumnVisible = _ref.stickyLeftColumnVisible,
      stickyRightColumnVisible = _ref.stickyRightColumnVisible,
      stickyTop = _ref.stickyTop,
      isHeader = _ref.isHeader;
  var index = 0;
  return React.createElement(React.Fragment, null, Children.map(children, function (child) {
    if (!child) {
      return null;
    }

    var stickyAlignment;
    var stickyOffset;
    var stickyColumnShadowVisible = false;

    if (stickyColumns && index in stickyColumns) {
      stickyAlignment = stickyColumns[index].alignment;
      stickyOffset = stickyColumns[index].offset;
      stickyColumnShadowVisible = stickyColumns[index].edge;
    }

    var stickyVisible = stickyTopVisible || stickyAlignment === LEFT && stickyLeftColumnVisible || stickyAlignment === RIGHT && stickyRightColumnVisible;
    var stickyShadowVisible = stickyTopVisible || stickyColumnShadowVisible;
    index += 1;
    return React.cloneElement(child, {
      stickyTop: stickyTop,
      stickyVisible: stickyVisible,
      stickyAlignment: stickyAlignment,
      stickyOffset: stickyOffset,
      stickyShadowVisible: stickyShadowVisible,
      isHeader: isHeader
    });
  }));
};